import Store from "store"
import { SharedModalConfirmActionShow } from "store/actions"

const onConfirmDelete = function(selected) {
  this.collection.delete.selected = selected
  Store.dispatch(
    SharedModalConfirmActionShow(
      "Are you sure want to delete this item?",
      this.collection.delete
    )
  )
}
export default onConfirmDelete